import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A single-page app does not scroll or move focus by itself:
 * new page → top and focus on <main>; link with #hash → that section.
 */
const ScrollManager: React.FC = () => {
  const { pathname, hash } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    const id = decodeURIComponent(hash.slice(1));
    const target = id ? document.getElementById(id) : null;
    if (target) {
      target.scrollIntoView({ block: 'start' });
    } else {
      window.scrollTo(0, 0);
    }
    if (!first.current && !target) {
      document.getElementById('contenido')?.focus({ preventScroll: true });
    }
    first.current = false;
  }, [pathname, hash]);

  return null;
};

export default ScrollManager;
